module.exports = "../study/imgs/maps/Nagano/S8/WaterEnvironment/Chlave/Nagano_Chlave_MIROC5_RCP85_Mid.png";